import React from 'react'
import Box from '@material-ui/core/Box'
import SectionTitle from 'components/section-title'
import UpcomingLessons from './upcoming-lessons'
import RecentLeads from './recent-leads'
import useStyles from './styles'

const ManageBusiness = ({ upcomingLessons, lessonsLoading }) => {
  const classes = useStyles()

  return (
    <Box className={classes.section}>
      <SectionTitle size="large" className={classes.sectionTitle}>
        Manage your coaching business
      </SectionTitle>
      <Box className={classes.grid}>
        <UpcomingLessons lessons={upcomingLessons} loading={lessonsLoading} />
        <RecentLeads />
      </Box>
    </Box>
  )
}

export default ManageBusiness
